import routesMenuCompany from './routesMenuCompany'
import routesMenu from './routesMenu'

const menuRoutes = [
  ...routesMenuCompany,
  ...routesMenu,
]

export default menuRoutes